module.exports = __webpack_public_path__ + "static/media/cleanbill-platforms.ddc35ea0.png";